import { registerEnum } from '@adornis/baseql/metadata/register.js';

export enum CompanyRegistrationStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

registerEnum({ enum: CompanyRegistrationStatus, name: 'CompanyRegistrationStatus' });
